import {
  AdaptedJourney,
  AdaptedResult,
  AdaptedSegment,
  AdaptedSolution,
  AirportAdapterResponse,
  AirportData,
  ResultsData,
} from "../interfaces/results.interface";

export const AirportAdapter = (
  airports: AirportAdapterResponse[]
): AirportData[] =>
  airports.map(a => ({
    id: a._id,
    name: `${a.iata} ${a.name}, ${a.city}, ${a.countryName}`,
    city: a.city,
    country: a.countryName,
    airportName: a.name,
  }));

export const ResultsAdapter = (response: ResultsData | null): AdaptedResult => {
  if (!response)
    return {
      token: '',
      cacheToken: '',
      solutions: [],
      filters: null,
      flexCalendar: null,
    };

  const {
    airportsMap,
    airlinesMap,
    jorneysMap,
    segmentsMap,
    token,
    solutions,
    cacheToken,
    filter,
    flexCalendar,
  } = response;

  const adaptedSolutions: AdaptedSolution[] = solutions.map(solution => {
    const adaptedAssociations = solution.data.associations.map(association => {
      const adaptedJourneys: AdaptedJourney[] = association.journeys.map(
        journey => {
          const journeyInfo = jorneysMap[journey.journeyId];

          const segments: AdaptedSegment[] = journey.segmentIds.map(
            segmentId => {
              const segment = segmentsMap[segmentId];
              const segmentData = segment.segmentData;

              const departureAirport = airportsMap[segmentData.departure];
              const arrivalAirport = airportsMap[segmentData.arrival];
              const marketingCompany =
                airlinesMap[segmentData.marketingCompany];
              const operatingCompany =
                airlinesMap[segmentData.operatingCompany];

              return {
                departureAirport,
                arrivalAirport,
                departureDate: segmentData.departureDate,
                arrivalDate: segmentData.arrivalDate,
                marketingCompany,
                operatingCompany,
                transportNumber: segmentData.transportNumber,
                cabin: segment.cabin,
                baggage: segment.baggage,
                classOfService: segment.classOfService,
                fareName: segment.fareName,
                fareType: segment.fareType,
                familyName: segment.familyName,
                seats: segment.seats,
                technicalStops: segmentData.technicalStops,
              };
            }
          );

          return {
            journeyId: journey.journeyId,
            duration: journeyInfo.duration,
            formattedDuration: journeyInfo.formattedDuration,
            layovers: journeyInfo.layovers,
            context: journeyInfo.context,
            segments,
          };
        }
      );

      return {
        validatingCompany: airlinesMap[association.validatingCompany],
        journeys: adaptedJourneys,
      };
    });

    return {
      id: solution.id,
      associations: adaptedAssociations,
      price: solution.priceBreakDown,
      pricePerPax: solution.priceBreakDownPerPax,
      isTwoWay: solution['2ow'],
    };
  });

  return {
    token,
    cacheToken,
    solutions: adaptedSolutions,
    filters: filter,
    flexCalendar,
  };
};
